<template>
  <div>
    <router-link
      v-if="isaudit == 1"
      :to="{ name: 'MWeekABC' }"
      class="gc-header-top"
    >评级
    </router-link
    >
    <!-- <div class="search-wrap">
            <div class="left" @click="showPicker=true">
                {{startDate?startDate:'请选择时间'}}
            </div>
            <div class="right">
                <van-search v-model="keywords" placeholder="请输入搜索关键词" />
            </div>
        </div>
        <van-popup v-model="showPicker" position="bottom" >
            <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年月日"
            :min-date="minDate"
            @cancel="showPicker=false"
            @confirm="confirmPicker"
            />
        </van-popup> -->

    <ul class="list-weekend-menu">
      <li class="item">
        <div class="title">{{ planInfo.WeekName }}</div>
        <div class="info-wrap">
          <div class="info-p">
            <span class="t">时间：</span>{{ planInfo.WeekDate }}
          </div>
          <div class="info-p">
            <span class="t">内容：</span>
            <div class="info">
              <p v-for="(item, index) in planInfo.Lst" :key="index">
                {{ index + 1 }}.{{ item.ProjectName }}
              </p>
            </div>
          </div>
          <div class="info-p">
            <span class="t">备注：</span>
            <textarea
              @focus="isFocus = true"
              @blur="isFocus = false"
              class="textarea"
              v-model="planInfo.WeekContent"
              placeholder="请输入备注信息"
            ></textarea>
          </div>
          <div class="info-p">
            <div
              class="submit-btn"
              :class="{ dis: isFocus == false }"
              @click="submitABC"
            >
              提交
            </div>
          </div>
        </div>
      </li>
      <li class="item">
        <div class="title">{{ summaryInfo.WeekName }}</div>
        <div class="info-wrap">
          <div class="info-p">
            <span class="t">时间：</span>{{ summaryInfo.WeekDate }}
          </div>
          <div class="info-p">
            <span class="t">内容：</span>
            <div class="info">
              <p v-for="(item, index) in summaryInfo.Lst" :key="index">
                {{ index + 1 }}.{{ item.ProjectName }}
              </p>
            </div>
          </div>
          <div class="info-p">
            <span class="t">备注：</span>
            <div class="textarea dis">
              {{ summaryInfo.WeekContent ? summaryInfo.WeekContent : "暂无" }}
            </div>
          </div>
          <div class="info-p">
            <span class="t">评级：</span>
            <div class="abc-wrap">
              <div class="abc" :class="{ a: summaryInfo.WeekRate == 'A' }">
                A
              </div>
              <div class="abc" :class="{ b: summaryInfo.WeekRate == 'B' }">
                B
              </div>
              <div class="abc" :class="{ c: summaryInfo.WeekRate == 'C' }">
                C
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      summaryInfo: {},
      planInfo: {},
      areaValue: "",
      minDate: new Date(2020, 1, 1),
      currentDate: new Date(),
      showPicker: false,
      keywords: "",
      startDate: "",
      isaudit: localStorage.getItem("isaudit"),
      isFocus: true //是否聚焦
    };
  },
  mounted() {
    this.WebGetUserWeekItem();
  },
  methods: {
    confirmPicker(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = e.getDate();
      day = day < 10 ? "0" + day : day;
      this.startDate = year + "-" + month + "-" + day;
      this.showPicker = false;
      this.WebGetUserWeekItem();
    },
    WebGetUserWeekItem() {
      let data = {
        UserSysno: localStorage.getItem("UserSysno")
      };
      this.$baseajax.normalJsonp(
        this.$base.baseProject + "/WebGetUserWeekItem",
        data,
        res => {
          console.log("abc", res);
          res = res.WebGetUserWeekItemResult;
          if (res.ResponseCode == 1) {
            this.summaryInfo = res.WeekConc;
            this.planInfo = res.WeekPlan;
          }
        },
        err => {
        }
      );
    },
    submitABC() {
      if (!this.planInfo.WeekContent) {
        this.$toast("请输入备注信息");
        return;
      }
      let data = {
        UserSysno: localStorage.getItem("UserSysno"),
        WeekContent: this.planInfo.WeekContent
      };
      this.$baseajax.sliceRequest(
        this.$base.baseProject + "/WebGetSetUserWeekItem",
        data,
        res => {
          console.log(res);
          if (res.ResponseCode == 1) {
            this.$toast("提交成功");
          }
        },
        err => {
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/base.less";

.gc-header-top {
  position: absolute;
  top: 0.4rem;
  right: 0.28rem;
  // width: 0.42rem;
  // height: 0.42rem;
  z-index: 99;
  font-size: 0.37rem;
  color: #fff;
  // background-image:url('~@/assets/admin2.png');
  background-size: contain;
  background-repeat: no-repeat;
}

.search-wrap {
  margin: 0.28rem 0.28rem 0;
  padding: 0.18rem 0.25rem;
  background-color: #ffffff;
  box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.1);
  border-radius: 0.27rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    font-size: 0.33rem;
    color: #333333;
    padding-right: 0.25rem;
    margin-right: 0.25rem;
    border-right: 1px solid #c8c8c8;
  }

  .right {
    // width: 7rem;
    flex: 1;
    min-width: 0;
  }

  .van-search,
  .van-search .van-cell {
    padding: 0;
  }

  /deep/ .van-icon-search {
    color: #d1d1d1;
  }

  .van-search__content {
    background: #fff;
    padding-left: 0;
  }

  /deep/ .van-field__control {
    font-size: 0.33rem;
  }
}

.gc-list-manage-wrap {
  padding-bottom: 1.6rem;
}

.list-weekend-menu {
  padding-left: 0.28rem;
  padding-right: 0.28rem;

  .item {
    margin-top: 0.28rem;
    padding: 0.48rem;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
    border-radius: 0.27rem;

    .title {
      font-size: 0.4rem;
      color: #333333;
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.3rem;

      span {
        min-width: 0.44rem;
        padding: 0 0.1rem;
        height: 0.44rem;
        line-height: 0.44rem;
        border-radius: 100%;
        font-size: 0.32rem;
        color: #ffffff;
        background-color: @color;
        text-align: center;
      }
    }

    .info-p {
      display: flex;
      font-size: 0.3rem;
      color: #888888;
      margin-top: 0.1rem;

      span.t {
        width: 1rem;
        flex: 0 0 1rem;
        font-size: 0.32rem;
        color: #666666;
      }

      p {
        margin-bottom: 0.15rem;
      }

      .textarea {
        width: 100%;
        margin-bottom: 0.2rem;
        min-height: 3rem;
        background-color: #f0f0f0;
        border-radius: 0.13rem;
        line-height: 1.6;
        padding: 0.2rem 0.3rem;
        font-size: 0.32rem;
        color: #888;
        resize: vertical;

        &.dis {
          background: none;
          padding: 0;
          min-height: 0;
        }
      }

      .submit-btn {
        width: 100%;
        margin-top: 0.5rem;
        height: 1rem;
        line-height: 1rem;
        background-color: #D32F2F;
        box-shadow: 0rem 1px 0.09rem 0rem rgba(26, 26, 26, 0.29);
        border-radius: 0.2rem;
        font-size: 0.47rem;
        color: #ffffff;
        text-align: center;

        &.dis {
          background-color: #ddd;
          color: #666;
          box-shadow: none;
        }
      }
    }

    .abc-wrap {
      display: flex;

      .abc {
        width: 0.64rem;
        margin-right: 0.2rem;
        background-color: #d3d3d3;
        border-radius: 0.07rem;
        font-size: 0.3rem;
        color: #fffefe;
        text-align: center;
      }

      .a {
        background-color: #ff7200;
      }

      .b {
        background-color: #D32F2F;
      }

      .c {
        background-color: #ffeb7a;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/manage/WeekABC.vue